<div [formGroup]="form" class="form-group color-picker-group" [ngClass]="field?.styleClass">
  <label *ngIf="field.label" [for]="field.name">
    {{ field.label }}{{ field.validation?.required ? '*' : '' }}
  </label>
  <app-info-icon
    [message]="field.infoIconMessage"
    *ngIf="field.infoIconMessage"
  ></app-info-icon>
  <div class="form-theme-control">
    <div [style.background]="formValue" class="color-pickers"></div>
    <div class="color-code">{{ formValue }}</div>
    <div class="color-icon">
      <span class="iconRing"></span>
      <span class="iconRing"></span>
      <input
        [colorPicker]="formValue"
        [cpOutputFormat]="'hex'"
        (colorPickerChange)="onChangeColor($event)"
        class="form-control cursor-pointer"
        [formControlName]="field.name"
        [id]="field.name"
      />
    </div>
  </div>
  <app-validation-errors
    [control]="form.get(field.name)"
    [field]="field"
  ></app-validation-errors>
</div>
